<template>
  <div class="js-basedata-faultcode app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-form 
          :model="listQuery" 
          label-suffix="：" 
          :label-width="$t('diagnostics.faultcodemanage.faultcode.searchLabelWidth')">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.faultcode')">
                <el-input v-model="listQuery.faultCode" clearable :placeholder="$t('diagnostics.faultcodemanage.faultcode.faultcode')" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.faultname')">
                <el-input v-model="listQuery.faultName" clearable :placeholder="$t('diagnostics.faultcodemanage.faultcode.faultname')" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.brand')">
                <el-select v-model="listQuery.brandId" filterable clearable :placeholder="$t('diagnostics.faultcodemanage.faultcode.brand')">
                  <el-option v-for="(item,index) in brandList" :key="index" :label="item.test" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-show="collapse">
            <el-col :span="6">
              <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.ispopfault')">
                <el-radio-group v-model="listQuery.isPush">
                  <el-radio label="">
                    {{ $t('diagnostics.faultcodemanage.faultcode.all') }}
                  </el-radio>
                  <el-radio :label="0">
                    {{ $t('diagnostics.faultcodemanage.faultcode.no') }}
                  </el-radio>
                  <el-radio :label="1">
                    {{ $t('diagnostics.faultcodemanage.faultcode.yes') }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <app-search-button
        slot="bottom"
        @click-collapse="handleCollapse"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter=true"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-export="handleExport"
      @click-import="importVisible=true"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @row-click="rowClick"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div v-if="item.prop==='faultLevel'">
            <span>{{ scope.row[item.prop] | switchText(item.prop) }}</span>
          </div>
          <div v-else-if="item.prop==='isPush'">
            <span
              :class="scope.row[item.prop]===0?'errors':'defaults'"
            >
              {{ scope.row[item.prop] | switchText(item.prop) }}
            </span>
          </div>
          <div v-else-if="item.prop==='faultName' || item.prop==='faultContent' || item.prop==='remark'">
            <el-popover
              v-if="scope.row[item.prop]"
              placement="top-start"
              :width="300"
              trigger="hover"
              :visible-arrow="false"
            >
              <div v-if="scope.row[item.prop].length > 500" style="min-height:15px;height:160px;">
                  <el-scrollbar style="height:100%" wrap-class="default-scrollbar__wrap">
                    <div>{{scope.row[item.prop]}}</div>
                  </el-scrollbar>
              </div>
              <span v-else>{{scope.row[item.prop]}}</span>
              <span slot="reference">{{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}</span>
            </el-popover>
            <span v-if="!scope.row[item.prop]">/</span>
          </div>
          <div v-else>
            <span>{{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="$t('public.operation')"
        width="100px"
        align="center"
      >
        <template slot-scope="scope">
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
          <div>
            <el-button type="primary" size="mini" @click="handleAudit(scope.row)">
              {{ $t('public.view') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 新增编辑dialog弹窗 -->
    <add-update-dialog
      :visibles.sync="addUpdateVisible"
      :is-edit="isEdit"
      :data="isEdit?tableRow:{}"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
    <!-- 查看dialog弹窗 -->
    <detail-dialog
      :visibles.sync="detailVisible"
      :data="tableRow"
    />
    <!-- 导入dialog弹窗 -->
    <import-dialog
      action="api/faultcode/importFaultCode"
      :template-url="$t('excelTemplate.faultCode')"
      :visibles.sync="importVisible"
      @upload-success="reloadList"
    >
      <result-dialog
        :visibles.sync="resultVisible"
        :data="importResult"
        :text="$t('diagnostics.faultcodemanage.faultcode.faultcode')"
        :keys="'faultcode'"
        :is-show="false"
      />
    </import-dialog>
  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// 组件
import AddUpdateDialog from './components/addUpdateDialog'
import importDialog from '@/components/importDialog'
import resultDialog from '@/components/resultDialog'
import detailDialog from './components/detailDialog'
// request
import { getFaultCode, deleteFaultCode, exportFaultCode, getBrand } from '@/api/fault/faultCode'

export default {
  name: 'faultCode',
  components: { AddUpdateDialog, importDialog, resultDialog, detailDialog },
  filters: {
    switchText(val, type) {
       
      if (type === 'faultLevel') {
        return val === 1 ? vm.$t('diagnostics.faultcodemanage.faultcode.level1') : val === 2 ? vm.$t('diagnostics.faultcodemanage.faultcode.level2') : val === 3 ? vm.$t('diagnostics.faultcodemanage.faultcode.level3') : val === 4 ? vm.$t('diagnostics.faultcodemanage.faultcode.level4') : ''
      } else if (type === 'isPush') {
        return val === 0 ? vm.$t('diagnostics.faultcodemanage.faultcode.no') : val === 1 ? vm.$t('diagnostics.faultcodemanage.faultcode.yes') : ''
      } else {
        return val
      }
    }
  },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      listQuery: {
        faultCode: '',
        faultName: '',
        brandId: '',
        isPush: ''
      },
      brandList: [],
      showfilter: false,
      tableList: [
        { value: this.$t('diagnostics.faultcodemanage.faultcode.faultcode'), prop: 'faultCode', sortable: 'custom', position: 'center', width: this.$t('diagnostics.faultcodemanage.faultcode.tablewidth.faultcode'), checked: true },
        { value: this.$t('diagnostics.faultcodemanage.faultcode.faultname'), prop: 'faultName', sortable: 'custom', position: 'center', width: '320px', checked: true },
        // { value: vm.$t('diagnostics.faultcodemanage.faultcode.faultlevel'), prop: 'faultLevel', sortable: 'custom', position: 'center', width: vm.$t('diagnostics.faultcodemanage.faultcode.tablewidth.faultlevel'), checked: true },
        { value: this.$t('diagnostics.faultcodemanage.faultcode.detailFaulcode'), prop: 'faultContent', sortable: 'custom', position: 'center', width: '320px', checked: true },
        { value: this.$t('diagnostics.faultcodemanage.faultcode.brand'), prop: 'specificBrand', sortable: 'custom', position: 'center', width: this.$t('diagnostics.faultcodemanage.faultcode.tablewidth.specificBrand'), checked: true },
        { value: this.$t('diagnostics.faultcodemanage.faultcode.ispopfault'), prop: 'isPush', sortable: 'custom', position: 'center', width: this.$t('diagnostics.faultcodemanage.faultcode.tablewidth.ispopfault'), checked: true },
        { value: this.$t('diagnostics.faultcodemanage.faultcode.createdon'), prop: 'createdOn', sortable: 'custom', position: 'center', width: this.$t('diagnostics.faultcodemanage.faultcode.tablewidth.createdon'), checked: true },
        { value: this.$t('public.note'), prop: 'remark', position: 'center', width: '320px', checked: false }
      ],
      // authouizeList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      addUpdateVisible: false,
      importVisible: false,
      resultVisible: false,
      importResult: {},
      isEdit: false,
      tableRow: {},
      detailVisible: false
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  mounted() {
    this.getBrandList()
  },
  methods: {
    // 车辆品牌
    getBrandList() {
      getBrand().then(({ data }) => {
        if (data.code === 0) {
          this.brandList = data.data || []
        }
      })
    },
    // 导入成功之后刷新list
    reloadList(data) {
      this.importResult = data
      if (data.failedList.length === 0 || !data.failedList) {
        this.resultVisible = false
        this.importVisible = false
      } else {
        this.resultVisible = true
      }
      // this.resultVisible = true
      this.listLoad()
    },
    // 加载数据
    listLoad() {
      this.listLoading = true
      getFaultCode(this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.tableRow = {}
          this.list = data.data
          this.total = data.total
        }
        this.listLoading = false
      }).catch(()=>{
         this.listLoading = false
      })
    },
    // 点击列
    rowClick(row) {
      this.tableRow = {}
      this.list.some((item, index) => {
        if (item.faultCodeId === row.faultCodeId) {
          row.$index = index
        }
      })
      this.tableRow = row
    },
    // 判断是否选中
    tableRowIsSlect() {
      const { $index } = this.tableRow
      if ($index === undefined) {
        return false
      } else {
        return true
      }
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 新增成功
    addComplete() {
      this.listLoad()
    },
    // 编辑
    handleUpdate() {
      if (this.tableRowIsSlect()) {
        this.isEdit = true
        this.addUpdateVisible = true
      } else {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
          .then(() => {})
          .catch(() => {})
      }
    },
    // 编辑成功
    updateComplete() {
      this.listLoad()
    },
    // 删除
    handleDelete() {
      if (!this.tableRowIsSlect()) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      const deleteData = {
        faultCodeId: this.tableRow.faultCodeId,
        faultCode: this.tableRow.faultCode
      }
      this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
        .then(() => {
          deleteFaultCode(deleteData).then(({ data }) => {
            if (data.code === 0) {
              if (this.list && this.list.length === 1) {
                this.listQuery.pageNum =
                  this.listQuery.pageNum > 1
                    ? this.listQuery.pageNum - 1
                    : this.listQuery.pageNum
                this.listLoad()
              } else {
                this.list.splice(this.tableRow.$index, 1)
                this.tableRow = {}
              }
              this.total--
              this.$message.success({
                message: this.$t('public.deleteSuccess'),
                duration: 2 * 1000
              })
            }
          })
        })
        .catch(() => {})
    },

    // 导出
    handleExport() {
      exportFaultCode(this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          //
        }
      })
    },
    // 规则明细
    handleAudit(row) {
      this.tableRow = row
      this.detailVisible = true
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
